import React, {useState, useEffect} from 'react';
import {useLocation, Redirect} from 'react-router-dom';
import {curry} from 'ramda';
import wrap from 'wraptile';
import ErrorBoundary from '@pluto/error-boundary/ErrorBoundary';
import AppSidebar from '../AppSidebar/AppSidebar';
import getAllowedRoutesComponent from './RolesRoutes';
import AppHeader from '../AppHeader/AppHeader';
import {baseRoutes} from './routes';
import {AppRouterContainerProps} from './AppRouterTypes';
import {useDispatch} from 'react-redux';
import {LOGIN_START} from '../../Login/Redux/LoginActions';

export const handleSidebar = curry((setOpen, isOpen) => {
    setOpen(isOpen);
});

export const handleUser = wrap(({dispatch}: any) => {
    const jwt = localStorage.getItem('jwt') || '';

    dispatch({
        type: LOGIN_START,
        jwt
    });
});

export default function AppRouterContainer({
    user,
}: AppRouterContainerProps) {
    const {isAuthenticated, roles} = user;
    const location = useLocation();
    const dispatch = useDispatch();
    const [isOpen, setOpen] = useState<boolean>(false);
    const onSidebarToggle = handleSidebar(setOpen);
    const handleLaunch = handleUser({
        dispatch,
    });
    const RolesRoutes = getAllowedRoutesComponent(roles);
    useEffect(handleLaunch, []);

    if (!isAuthenticated) {
        return <Redirect to={baseRoutes.login} />;
    }
    return (
        <div className="root">
            <AppHeader isOpen={isOpen} />
            <AppSidebar
                roles={roles}
                isOpen={isOpen}
                handleSidebarClose={onSidebarToggle}
            />
            <main className="root__content">
                <div className="root__toolbar" />
                <ErrorBoundary key={location.pathname}>{RolesRoutes}</ErrorBoundary>
            </main>
        </div>
    );
}
